import { baseURL } from "./CommonUrl";
import { apiRequest } from "./CmnService";

export const GetAboutUsService = async (data, cb) => {
    return apiRequest("GET", "get-aboutus-data", null, cb);
}

export const GetTermsAndConditionService = async (data, cb) => {
    return apiRequest("GET", "get-termsconditions-data", null, cb);
}

export const GetPrivacyPolicyService = async (data, cb) => {
    return apiRequest("GET", "get-privacy-data", null, cb);
}

export const GetFaqService = async (data, cb) => {
    return apiRequest("GET", "get-faqs-data", null, cb);
}

export const GetHelpSupportService = async (data, cb) => {
    return apiRequest("GET", "helpSupport", null, cb);
}

export const ContactUsService = async (data, cb) => {
    return apiRequest("POST", "add-contact-us", data, cb);
}
export const ContactInfoService = async (data, cb) => {
    return apiRequest("GET", "get-contact-info", null, cb);
}

export const EnquiryService = async (data, cb) => {
    return apiRequest("POST", "add-enquiry", data, cb);
}

export const getAllItineraryApi = async (data, cb) => {
    return apiRequest("POST", "get_all_user_itinerary_list", data, cb);
}

export const addItineraryLikeApi = async (data, cb) => {
    return apiRequest("POST", "add_itinerary_like", data, cb);
}

export const addItineraryRatingApi = async (data, cb) => {
    return apiRequest("POST", "add_itinerary_rating", data, cb);
}

export const addItineraryCommentApi = async (data, cb) => {
    return apiRequest("POST", "add_itinerary_comment", data, cb);
}

export const addItineraryItemRequestApi = async (data, cb) => {
    return apiRequest("POST", "add_private_itinerary_view_request", data, cb);
}

export const publicDetailServiceApi = async (data, cb) => {
    return apiRequest("POST", "get_itinerary_details", data, cb);
}

export const getAllCountryListApi = async (data, cb) => {
    return apiRequest("POST", "get_all_country_list", data, cb);
}

export const getGetConvertListApi = async (data, cb) => {
    return apiRequest("POST", "GetConvertList", data, cb);
}

export const getPropularTravelItinerariesApi = async (data, cb) => {
    return apiRequest("GET", "get_propular_travel_itineraries", null, cb);
}

export const getDestinationItinerariesApi = async (data, cb) => {
    return apiRequest("POST", "top_destination_itineraries_list", data, cb);
}

export const searchCitiesApi = async (data, cb) => {
    const fullURL = baseURL + `cityCountry?search=${data}`
    return apiRequest("GET", fullURL, null, cb);
}

export const getSubscriptionListService = async (data, cb) => {
    return apiRequest("POST", "list_subscription_plan", data, cb);
}

